module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/ko_tohoku-edb7de5f6b3d7361d3ebd91a1527994a.jpg";